import { PropsSyncer as e } from "./props-syncer.js";
import { createMyStore as t } from "./store.js";
import { StoreContext as n } from "./context.js";
import { useDatePickerStore as r } from "./use-date-picker-store.js";
import i from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
// src/design/forms/datepicker/core/models/provider.tsx
var c = ({ props: r, children: a }) => {
	let c = i.useRef(t(r)).current;
	return /* @__PURE__ */ s(n.Provider, {
		value: c,
		children: [/* @__PURE__ */ o(e, { ...r }), a]
	});
}, l = ({ children: e }) => {
	let t = r((e) => e);
	return /* @__PURE__ */ o(a, { children: e(t) });
};
export { l as DatePickerStoreConsumer, c as DatePickerStoreProvider };

//# sourceMappingURL=provider.js.map